// var EformSigner = window.EformSigner || {}
var EformSigner = function () {

  const COMMAND = "signJson";

  function EformSigner(inputData) {
    this.inputData = inputData;
    this.socket = null;
    this.signVerificationData = {};
    this.signData = {};
    this.url = this.getURL()
    this.maxTry = 5
    this.readyToCloseConnection = false
    this.getSomeData = false
  }

  EformSigner.prototype.setInputData = function (inputData) {
    this.inputData = inputData
  };
  EformSigner.prototype.getURL = function () {
    let scheme = "wss", host = "ereceptsigner.cz", port = 25576, query = "Sign";
    return scheme + "://" + host + ":" + port + "/" + query;
  };

  EformSigner.prototype.doSignConnection = function () {
    var self = this;
    return new Promise(function (resolve, reject) {

      self.checkInputData()
      try {
        self.socket = new WebSocket(self.url)
      } catch (t) {
        reject(t)
      }
      self.socket.onerror = function (t) {
        reject(t)
      }
      self.socket.onopen = function (e) {
        this.sendData(this.getSignData())
      }.bind(self)

      self.socket.onmessage = function (r) {
        this.getSomeData = true
        var resData = r.data;
        if (resData) {
          try {
            var a = JSON.parse(resData);
            self.processResponseData(a)
            // self.signData.signature ? resolve({signData: self.signData}) : reject("No data response from server")
            self.signData.signature ? resolve(self.signData) : reject("No data response from server")
          } catch (e) {
            reject("Response Data are not in JSON format")
          }
        } else {
          reject("No data response from server")
        }
      }
      self.socket.onclose = function (e) {
           if (1e3 !== e.code) {
          navigator.onLine || alert("You are offline. Please connect to the Internet and try again.")
        }
        if (!this.getSomeData) { //zadna obdrzena data - jinak by reject uz davno
          // console.log('CLOSE WITHOUT DATA')
          reject(new Event('error')) // kvuli podmince kdy se testuje na event
        }
      }.bind(self)
    })
  };

  EformSigner.prototype.sendData = function (e) {
     var t = JSON.stringify(e)
    this.socket.send(t)
  };

  EformSigner.prototype.processResponseData = function (resData) {
    if (resData.status) {
      this.serverStatus = resData.status
    }
    if (resData.version) {
      this.serverVersion = resData.version
    }
    if (resData.key && resData.salt) {
      this.signVerificationData.key = resData.key
      this.signVerificationData.salt = resData.salt
     }
    if (resData.signature && resData.certificate) {
      this.signData.signature = resData.signature
      this.signData.certificate = resData.certificate
      this.readyToCloseConnection = true
    }
  };
  EformSigner.prototype.checkInputData = function () {
    var misItem = [];
    if (!this.inputData || !this.inputData.dataGuid) {
      misItem.push("dataGuid")
    }
    if (!this.inputData || !this.inputData.json) {
      misItem.push("json")
    }
    if (misItem.length) throw new Error("Missing mandatory input data: [" + misItem.join(", ") + "]")
  };

  EformSigner.prototype.getSignData = function () {
    return {
      command: COMMAND,
      dataGuid: this.inputData.dataGuid,
      viewData: this.signVerificationData.key,
      firstName: this.inputData.firstName,
      surname: this.inputData.surname,
      json: this.inputData.json
    }
  };

  EformSigner.prototype.uuidv4 = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0
      var v = c === 'x' ? r : ((r & 0x3) | 0x8)
      return v.toString(16);
    });
  }

  EformSigner.prototype.trySignData = function (jsonvals, guid, maxTry) {
    if (maxTry) {
      this.maxTry = maxTry
    }
    if (!guid) {
      guid = this.uuidv4();
    }
    var data = {
      json: jsonvals,
      dataGuid: guid
    }
    this.setInputData(data)
    document.location = 'erpsign://guid=' + guid + '?port=25576?connectiontimeout=30?signaturetimeout=60'
    var self = this
    return new Promise(function (resolve, reject) {
      self.repeatSign().then(function (result) {
        resolve(result);
      }).catch(function (error) {
        reject(error)
      })
    })
  }
  EformSigner.prototype.repeatSign = function () {
    var self = this;
    return new Promise(function (resolve, reject) {

      self.doSignConnection()
        .then(function (result) {
          //console.log('OK result:', result)
          resolve(result);
        })
        .catch(function (error) {
          //console.log('KO err:', error)
          if (error instanceof Event) { //test jestli se socket vypnul automaticky
            if (self.maxTry-- > 0) {
              self.repeatSign().then(function (result) {
                resolve(result);
              }).catch(function (error) {
                reject(error)
              })
            } else {
              reject("submit.err.esignerNoConnect")
            }
          } else {
            reject("submit.err.esignerNoSign")
          }
        })
    })
  }

  return EformSigner
}()

if (typeof module !== 'undefined') {
  module.exports = {
    EformSigner: EformSigner
  }
}
// only ES6 - no ie11
// export  {EformSigner};

